import { createContext, useEffect, useState, useMemo } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { FiltersAndSegmentsContextType, FiltersAndSegmentsInitialState} from "../../../types/types";
import { fetchConfigFor360, } from "../../../Api";
import { getFilters, updateFilter } from "../../../api/customizations";
import { showNotification } from "@mantine/notifications";
import { Text, Flex, Box } from "@mantine/core";
import { IconCheck } from "@tabler/icons";

const FiltersAndSegmentsContext = createContext<FiltersAndSegmentsContextType>(FiltersAndSegmentsInitialState);

const FiltersAndSegmentsContextContextProvider = ( { children } : { children: React.ReactNode } ) => {

  const auth0 = useAuth0();
  
  const [ideasFiltersConfig, setIdeasFiltersConfig] = useState<{
    evidence:any,
    idea:any
  }>(
    {
      evidence: {},
      idea: {},
    }
  );
  const [perspectiveConfigurations, setPerspectiveConfigurations] = useState<any[]>([]);
  const evidenceFilters = ideasFiltersConfig?.evidence || {}

  const filteredEvidenceFilters = Object.fromEntries(
    Object.entries(evidenceFilters).filter(([key, filterData]: [string, any]) => 
      filterData?.childFilters
    )
  );

  const filtersTypesArr = useMemo(() => {
    const baseArray = [{id: 1, name: 'Idea Attributes', parent : 'idea' }];
    
    Object.entries(filteredEvidenceFilters).forEach(([key, filterData]: [string, any], index: number) => {
      if (filterData?.label) {
        baseArray.push({
          id: baseArray.length + 1,
          name: filterData.label,
          parent: filterData.name
        });
      }
    });
    
    return baseArray;
  }, [filteredEvidenceFilters]);

  const handleUpdateFilter = (data: any)=>{

    let savedTo = ''

    if(data?.page === 'ideas-idea'){
      savedTo = 'ideas page and idea view'
    }

    else if(data?.page === 'perspective'){
      savedTo = 'perspectives'
    }

    else if(data?.page === 'customer360'){
      savedTo = 'customer 360 page'
    }

    updateFilter(data ,auth0)
      .then((res: any)=>{

        console.log(res)

      }).catch((e:any)=>{
        console.log(e)
      }).finally(()=>
       
        showNotification({
          title: "Saved Successfully!",
          color: "teal",
          message: (
            <Flex>
              <Box>
                {!data.add? 
                  <Text>Filter added to</Text>: <Text>Filter removed from</Text>
                }
              </Box> 
             
             
                  
              <Text ml={4}>{savedTo}</Text>
                
            </Flex>
          ),
          icon: <IconCheck size="1.1rem" />,
          autoClose: 3200,
        })
      )
      
  }

  const handleToggleFilterInPage = (property: string, parent: number, page: string, add: boolean) => {

    const foundParent = filtersTypesArr.find((filter: any)=> filter.id === parent)

    const dataObj: any ={
      property, parent: foundParent?.parent , page, add
    }

    handleUpdateFilter(dataObj)
  }

  const fetchConfig = () => {
  
    fetchConfigFor360(auth0)
      .then((res: any)=>{
        setIdeasFiltersConfig(res.ideasFiltersConfig)
        setPerspectiveConfigurations(res.perspectiveConfigurations)
      }).catch((e:any)=>{
        console.log(e)
      })
  }

  const fetchFilters = () => {
    getFilters(auth0)
      .then((res: any) => {
        setIdeasFiltersConfig(res.ideasFiltersConfig)
      }).catch((e: any) => {
        console.log(e)
      })
  }


  useEffect(() => {

    /* fetchFilters() */

    fetchConfig() 
 
  }, []);


  return (
    <FiltersAndSegmentsContext.Provider
      value={{
        ideasFiltersConfig,
        handleToggleFilterInPage,
        filtersTypesArr,
        perspectiveConfigurations
      }}
    >
      {children}
    </FiltersAndSegmentsContext.Provider>
  );
};

export { FiltersAndSegmentsContext, FiltersAndSegmentsContextContextProvider };
export default FiltersAndSegmentsContext;